module.exports = __webpack_public_path__ + "img/bekir-donmez-eofm5R5f9Kw-unsplash.07835b07.jpg";